import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../../assets/flexbox-helpers.scss';
import { InputWidthValues } from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';
import { MdrContactDetailsSource } from '../../common/types';

export const templateMdrImportOptions = document.createElement('template');

templateMdrImportOptions.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>

    <gz-form-field id='import-options-multi-tenancy'>
      <gz-radio-group gz-form-input selectedOption=''>

        <div id="partner-contact-container" class='dropdown-container'>
          <gz-radio id='partner-contact' class='mdr-option-selector' value="${MdrContactDetailsSource.PARTNER_CONTACT}" label=''></gz-radio>
          <gz-form-field id='select-partner-form-field' class='selector-form-field' label=''>
            <gz-single-select-complex gz-form-input hasFormLabelWidth labelWidth="${InputWidthValues.LARGE}"></gz-single-select-complex>
          </gz-form-field>
        </div>

        <div id='partner-account-container' class='dropdown-container mt-1'>
          <gz-radio id='partner-account' class='mdr-option-selector' value="${MdrContactDetailsSource.GZ_ACCOUNT}" label=''></gz-radio>
          <gz-form-field id='select-account-form-field' class='selector-form-field' label=''>
            <gz-single-select-complex gz-form-input hasFormLabelWidth labelWidth="${InputWidthValues.LARGE}"></gz-single-select-complex>
          </gz-form-field>
        </div>

      </gz-radio-group>
    </gz-form-field>

    <gz-form-field id='self-form-field' class='selector-form-field' label=''>
      <gz-single-select-complex gz-form-input hasFormLabelWidth labelWidth="${InputWidthValues.LARGE}"></gz-single-select-complex>
    </gz-form-field>
  </div>
`;
